export const LOGO_SIZE = 74;
export const LOGO_TRANSLATE = 12;
export const SHADOW_OPACITY = 0.12;
